import { createContext } from 'react'

export type AdvanceSelectionAwayFromFn = (key: string) => void

/*
 * Provides a function that advances the sidebar's ?selected= URL param to
 * the neighbor when the given row key is currently selected. InboxRow calls
 * this BEFORE firing an archive mutation on the selected row so the URL
 * doesn't end up pointing at a row that's about to disappear from the list
 * (which would orphan the j/k findIndex lookup and cause a sidebar flash).
 *
 * No-op when the key is not the current selection, or when used outside of
 * an InboxArchiveAdvanceContext provider.
 */
export const InboxArchiveAdvanceContext =
  createContext<AdvanceSelectionAwayFromFn | null>(null)
